import { CdkTableModule } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbTooltipModule, NgbModalModule, NgbTypeaheadModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { UiSwitchModule } from "ngx-ui-switch";
import { NavigationModule } from './navigation/navigation.module';
import { FormElementsModule } from './form-elements/form-elements.module';
import { TableModule } from './table/table.module';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { StepperComponent } from './stepper/stepper.component';
import { SafePipe } from './pipes/safe.pipe';
import { AuditHistoryComponent } from './audit-history/audit-history.component';
import { AuthGuard } from 'app/core/security/auth.guard';
import { PermissionConst } from 'app/core/security/generated/Permission';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

const routes = [
	{
		path: 'audit-history/:id',
		component: AuditHistoryComponent,
		canActivate: [AuthGuard],
		canLoad: [AuthGuard],
		data: { security: PermissionConst.coreFeatures }
	}
];

/**
 * SharedModule exists to make commonly used components, directives,
 * and pipes available for use in the templates of components throughout
 * the application.
 */
@NgModule({
	declarations: [StepperComponent, SafePipe, AuditHistoryComponent],
	imports: [
		CommonModule,
		FormElementsModule,
		NgSelectModule,
		CdkTableModule,
		CdkStepperModule,
		// Add ng-bootstrap modules we want to use
		NgbTooltipModule,
		NgbDatepickerModule,
		NgbModalModule,
		NgbTypeaheadModule,
		NgbNavModule,
		FormsModule,
		NavigationModule,
		TableModule,
		ReactiveFormsModule,
		UiSwitchModule,
		FontAwesomeModule,
		RouterModule.forChild(routes)
	],
	exports: [
		CommonModule,
		FormElementsModule,
		NgSelectModule,
		CdkTableModule,
		// Add ng-bootstrap modules we want to use
		NgbTooltipModule,
		NgbDatepickerModule,
		NgbModalModule,
		NgbTypeaheadModule,
		NgbNavModule,
		FormsModule,
		NavigationModule,
		TableModule,
		ReactiveFormsModule,
		CdkStepperModule,
		StepperComponent,
		UiSwitchModule,
		SafePipe,
		AuditHistoryComponent,
		FontAwesomeModule,
	]
})
export class SharedModule {}
